import React, { Component } from 'react'
import { withStyles } 		from 'material-ui/styles'
import { connect } 			from 'react-redux'

const styles = {}

class SchoolTypes extends Component {
	constructor(props) {
		super(props)

		this.state = {}
	}

	render() {
		return(
			<div>
				SchoolTypes
			</div>
		)
	}
}

export default withStyles(styles)(SchoolTypes);



// WEBPACK FOOTER //
// ./src/components/content/SchoolTypes.js